import React, { useEffect, useState, useCallback, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { API_BASE_URL } from "../config";

const ProductCustomization = () => {

  const [user, setUser] = useState("");


  const [editorData, setEditorData] = useState("");
  const [categories, setCategories] = useState([]);
  const [metals, setMetals] = useState([]);
  //const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedMetal, setSelectedMetal] = useState("");
  const [qtyDiamond, setQtyDiamond] = useState("");
  const [diamondCarat, setDiamondCarat] = useState("");
   const [Size, setSize] = useState("");
  // const [comments, setComments] = useState("");
  // const [deliveryDate, setDeliveryDate] = useState("");
  const [file, setFile] = useState(null);
  const [editingProductId, setEditingProductId] = useState(null);
  const descriptionRef = useRef(null);
  // Fetch categories, metals, and products

  const [formData, setFormData] = useState({
    categoryType: "",
    metalType: "",
    purityType: "",
    diamondQuality: "",
    diamondCaret: "",
    colorStone: "",
    finding: "",
    size: "",
    description: "",
    engraving: "",
    deliveryDate: "",
  });
  useEffect(() => {

    const storedUser = localStorage.getItem("user");
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);
    fetchCategories();
    fetchMetals();
    
  }, []);

  // Fetch Categories
  const fetchCategories = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/Master/GetMaster`);
      if (!response.ok) throw new Error("Failed to fetch categories");

      const result = await response.json();
      setCategories(Array.isArray(result.data) ? result.data : []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  }, []);

  // Fetch Metals
  const fetchMetals = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/Master/GetMetal`);
      if (!response.ok) throw new Error("Failed to fetch metals");

      const result = await response.json();
      setMetals(Array.isArray(result.data) ? result.data : []);
    } catch (error) {
      console.error("Error fetching metals:", error);
      setMetals([]);
    }
  }, []);

  

  // Handle File Upload
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // Save or Update Product
  const handleSubmit = async () => {
    const productData = {
      Id: editingProductId || null,
      CategoryId: selectedCategory,
      MetalId: selectedMetal,
      Quality: qtyDiamond,
      Carat: diamondCarat,
      Size:Size,
      ProductDescription: editorData,
      Stage: "Authorisation Pending",      
      CreatedBy: "Partner",
      Status: "Pending",
      UserID: user?.userId,      
      ActionType: editingProductId ? "UPDATE" : "INSERT",
    };

    const formData = new FormData();
    formData.append("modelJson", JSON.stringify(productData));
    if (file) formData.append("Image", file);

    try {
      const response = await fetch(`${API_BASE_URL}/Order/InsertProductCustomizationBYPartener`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      alert(result.message || "Product saved successfully!");
   
      clearForm();
    } catch (error) {
      console.error("Error saving product:", error);
    }
  };


  // Populate Form for Editing
  const handleEdit = (product) => {
    setEditingProductId(product.id);
    setSelectedCategory(product.categoryId);
    setSelectedMetal(product.metalId);
    setQtyDiamond(product.qty);
    setDiamondCarat(product.carat);
    setSize(product.size);
    setEditorData(product.productDescription || "");
    // setAmount(product.amount || 0);
    // setDeliveryDate(product.deliveryDate || null);
    // setComments(product.comments || "");
    // Focus the input field after updating the state
    setTimeout(() => {
      descriptionRef.current?.focus();
    }, 100);


  };

  const handleConfirmAccept = (product) => {
    const isConfirmed = window.confirm("Are you sure you want to accept this product?");
    if (isConfirmed) {
      handleAccept(product);
    }
  };

  const handleAccept = async (product) => {
    try {
      const requestBody = {
        Id: product.id,
        CreatedBy: product.createdBy,
        Status: "Accepted",


      };
      const formData = new FormData();
      formData.append("modelJson", JSON.stringify(requestBody));
      const response = await fetch(`${API_BASE_URL}/Order/AcceptProduct`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert(result.message || "Product accepted successfully!");
       
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error("Error accepting product:", error);
      alert("An error occurred while accepting the product.");
    }
  };

  // Clear Form
  const clearForm = () => {
    setEditingProductId(null);
    setSelectedCategory("");
    setSelectedMetal("");
    setQtyDiamond("");
    setDiamondCarat("");
    setSize("");
    setEditorData("");
    setFile(null);
  };

  return (
    <>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />

          <div className="container mt-4">
            <div className="card">
              <div className="card-body">
                <h4>{editingProductId ? "Update Product Customization" : "Create Product Customization"}</h4>

                {/* Category & Metal Selection */}
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label>Category</label>
                    <select className="form-control" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label>Metal</label>
                    <select className="form-control" value={selectedMetal} onChange={(e) => setSelectedMetal(e.target.value)}>
                      <option value="">Select Metal</option>
                      {metals.map((metal) => (
                        <option key={metal.id} value={metal.id}>{metal.metalname}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <br></br>
                {/* Diamond Details */}
                <div className="row mt-3">
                  <div className="col-md-4">
                    <label>Diamond Quality</label>
                    <input type="text" className="form-control" value={qtyDiamond} onChange={(e) => setQtyDiamond(e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <label>Diamond Carat</label>
                    <input type="text" className="form-control" value={diamondCarat} onChange={(e) => setDiamondCarat(e.target.value)} />
                  </div>
                  <div className="col-md-4">
                    <label>Size</label>
                    <input type="text" className="form-control" value={Size} onChange={(e) => setSize(e.target.value)} />
                  </div>
                </div>
                <br></br>
                {/* Product Description Editor */}
                <div className="mt-3">
                  <label>Product Description</label>
                  <ReactQuill theme="snow" value={editorData} onChange={setEditorData}  style={{height:"200px"}}/>
                </div>

                {/* File Upload */}
                <div className="mt-3">
                  <label>Upload Image</label>
                  <input type="file" className="form-control" onChange={handleFileChange} accept="image/*" />
                </div>
                <br></br>
                {/* Buttons */}
                <div className="row mt-4">
                  <div className="col-md-3">
                    <button className="btn btn-primary btn-block" onClick={handleSubmit}>
                      {editingProductId ? "Update" : "Save"}
                    </button>
                  </div>
                  <div className="col-md-3">
                    <button className="btn btn-dark btn-block" onClick={clearForm}>
                      Clear
                    </button>
                  </div>
                </div>
                <br></br>
                {/* Product List Table */}
                {/* <div className="card mt-4">
                  <div className="card-body">
                    <h4>Product List</h4>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Metal</th>
                          <th>QTY Diamond</th>
                          <th>Diamond Carat</th>
                          <th>Description</th>
                          <th>Status</th>
                          <th>Stage</th>
                          <th>Comment</th>
                          <th>Delivery Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.length > 0 ? (
                          products.map((product) => (
                            <tr key={product.id}>
                              <td>{product.categoryname}</td>
                              <td>{product.metalname}</td>
                              <td>{product.qty}</td>
                              <td>{product.carat}</td>
                              <td dangerouslySetInnerHTML={{ __html: product.productDescription || "N/A" }} />
                              <td>
                                {product.status === "Approve By Admin" ? (
                                  <>

                                    <button onClick={() => handleConfirmAccept(product)} className="btn btn-success">
                                      Accept
                                    </button>
                                  </>
                                ) : (
                                  product.status
                                )}
                              </td>
                              <td>{product.stage}</td>
                              <td>{product.comments}</td>
                              <td>
                                {product.deliveryDate
                                  ? new Date(product.deliveryDate).toISOString().split('T')[0].split('-').reverse().join('-')
                                  : ""}
                              </td>
                              <td>
                                <a className="btn btn-sm btn-warning" href={`${Image_URL}Product/${product.attachment}`} download><i className="fa fa-download" aria-hidden="true"></i></a>
                                <button className="btn btn-sm btn-warning" onClick={() => handleEdit(product)}><i className="fa fa-edit" aria-hidden="true"></i></button></td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No products found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div> */}

              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>
    </>
  );
};

export default ProductCustomization;
